/* eslint-disable react-hooks/exhaustive-deps */
import { Form, Button } from 'antd'
import React, { useEffect } from 'react'
import { useTranslation } from 'next-i18next'
import { BigOrderItem } from 'src/core/models'
import { SendOutlined } from '@ant-design/icons'
import { showNotification } from 'src/core/helpers'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { CustomTextArea, CustomTextInput, CustomModal, CustomTitle } from 'src/components'
import { resetSendMessage, sendMessage, sendMessageSelector, userAuthenticatedState } from 'src/features'

interface ClaimCertificateModalProps {
  isModalVisible: boolean
  handleCancel: Function
  orderItem: BigOrderItem
}

const ClaimCertificateModal: React.FC<ClaimCertificateModalProps> = (props) => {
  const { isModalVisible, handleCancel, orderItem } = props
  const { t } = useTranslation()
  const [form] = Form.useForm()
  const dispatch = useAppDispatch()
  const userAuthenticate = useAppSelector(userAuthenticatedState)
  const {
    loading: loadingSendingMessage,
    success: successMessageSent,
    error: errorSentMessage
  } = useAppSelector(sendMessageSelector)

  const onClose = () => {
    form.resetFields()
    handleCancel()
  }

  const onFinish = (values: { subject: string, content: string }) => {
    dispatch(sendMessage({
      ...values,
      content: values.content,
      date: new Date(),
      read: true,
      receiver: 901,
      sender: userAuthenticate.id,
      uuid_message: '1',
      company: orderItem.project_company,
    }))
  }

  useEffect(() => {
    if (successMessageSent) {
      form.resetFields()
      dispatch(resetSendMessage())
      showNotification('success', t('Messages.MessageSendedSuccess'))
      handleCancel()
    }
    if (errorSentMessage) {
      form.resetFields()
      dispatch(resetSendMessage())
      showNotification('error', t('Messages.MessageError'))
      handleCancel()
    }
  }, [successMessageSent, errorSentMessage])

  return <>
    <CustomModal
      title={t('Transactions.ContactDeveloper')}
      footer={null}
      open={isModalVisible}
      onCancel={onClose}
    >
      <Form
        name='credentialsForm'
        onFinish={onFinish}
        autoComplete='off'
        form={form}
      >
        {/* Email */}
        <CustomTitle label={t('Messages.Subject')} className='label-input' type={null} />
        <CustomTextInput
          name={'subject'}
          placeholder={t('Transactions.SubjectPlaceholder')}
          required
        />

        {/* Content */}
        <CustomTitle label={t('Transactions.Content')} className='label-input' type={null} />
        <CustomTextArea
          name={'content'}
          placeholder={t('Transactions.ContentPlaceholder')}
          rows={5}
          required
        />

        {/* Buttons */}
        <Button
          type='primary'
          block
          htmlType='submit'
          className='mt-2'
          loading={loadingSendingMessage}
          icon={<SendOutlined />}
        >
          {loadingSendingMessage ? t('Transactions.SendingMessage') : t('Transactions.SendMessage')}
        </Button>
      </Form>
    </CustomModal>
  </>
}

export default ClaimCertificateModal
